import { RecoverCompletePage } from "@/features/auth/pages/RecoverComplete";

const RecoverComplete = () => {
  return <RecoverCompletePage />;
};

export default RecoverComplete;
